import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ConditionRetail } from "src/app/particulier/core/model/condition-retail";
import { ConditionRetailService } from "src/app/particulier/core/service/condition-retail.service";

@Component({
  selector: "app-form-edit-condition",
  templateUrl: "./form-edit-condition.component.html",
  styleUrls: ["./form-edit-condition.component.scss"],
})
export class FormEditConditionComponent implements OnInit {
  @Input() conditionId;

  requestId: number;

  condition: ConditionRetail;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _conditionRetailService: ConditionRetailService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getConditionRetailById(this.conditionId);
  }

  getConditionRetailById(conditionid) {
    this._conditionRetailService.getConditionRetailById(conditionid).subscribe(
      (data) => {
        this.condition = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(): void {
    this.spinner.show();
    this._conditionRetailService
      .putConditionRetail(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
